import { getCreate } from 'services/api/user/reminder/create';
import { getList } from 'services/api/user/reminder/list';
import { getDelete } from 'services/api/user/reminder/delete';
import { setProfileLastTouch } from 'utils/Socialization';
import {
  CREATE_REMINDER_INIT,
  CREATE_REMINDER_SUCCESS,
  CREATE_REMINDER_ERROR,
  LIST_REMINDER_INIT,
  LIST_REMINDER_SUCCESS,
  LIST_REMINDER_ERROR,
  DELETE_REMINDER_INIT,
  DELETE_REMINDER_SUCCESS,
  DELETE_REMINDER_ERROR,
} from './constants';

export const createReminder = (params = {}) => async dispatch => {
  dispatch({ type: CREATE_REMINDER_INIT });
  try {
    const fetch = await getCreate(params);
    if (fetch.response) {
      dispatch({ type: CREATE_REMINDER_SUCCESS, payload: fetch.response });
      dispatch(listReminder({ user_hash: params.user_hash }));
      if (fetch.lasttouch && fetch.lasttouch.reminder) {
        setProfileLastTouch(fetch.lasttouch.reminder);
      }
    }
  } catch (e) {
    dispatch({ type: CREATE_REMINDER_ERROR, payload: e });
  }
};

export const listReminder = (params = {}) => async dispatch => {
  dispatch({ type: LIST_REMINDER_INIT });
  try {
    const fetch = await getList(params);
    if (fetch.response && Array.isArray(fetch.response)) {
      dispatch({ type: LIST_REMINDER_SUCCESS, payload: fetch.response });
    } else {
      dispatch({ type: LIST_REMINDER_SUCCESS, payload: [] });
    }
  } catch (e) {
    dispatch({ type: LIST_REMINDER_ERROR, payload: e });
  }
};

export const deleteReminder = (params = {}) => async dispatch => {
  dispatch({ type: DELETE_REMINDER_INIT });
  try {
    const fetch = await getDelete({
      user_hash: params.user_hash,
      reminder_id: params.reminder_id,
    });
    if (fetch.response) {
      dispatch({
        type: DELETE_REMINDER_SUCCESS,
        payload: (params.showAlert && fetch.response) || null,
      });
      dispatch(listReminder({ user_hash: params.user_hash }));

      if (fetch.lasttouch && fetch.lasttouch.reminder) {
        setProfileLastTouch(fetch.lasttouch.reminder);
      }
    }
  } catch (e) {
    dispatch({ type: DELETE_REMINDER_ERROR, payload: e });
  }
};
